import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import CheckboxToggle from '../../core/components/CheckboxToggle'
import {EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED, sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd, updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd, loadContact} from '../actions'
import {ExcludeOpeningTicketPurposesFromInterventionPeriodCmd} from '../models'
import i18n from '../i18n'

function openingTicketPurposeAggregator(openingTicketPurposeIds) {
    return (result, openingTicketPurpose) => {
        if (openingTicketPurposeIds.indexOf(openingTicketPurpose.uid) < 0) {
            result.push(openingTicketPurpose.uid)
        }
        return result
    }
}

function defineCmdUpdate(interventionPeriod) {
    return {
        openingTicketPurposes: interventionPeriod.excludedOpeningTicketPurposes
    }
}

class ExcludeOpeningTicketPurposesFromInterventionPeriodForm extends Component {
    static propTypes = {
        interventionPeriod: PropTypes.object.isRequired,
        openingTicketPurposes: PropTypes.array.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd(update))
        }
    }

    _sendExcludeCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd(interventionPeriod.uid)).then(() => {
            return dispatch(loadContact())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, interventionPeriod, openingTicketPurposes, ...others} = this.props

        const excludedField = (field) => {
            const value = openingTicketPurposes.reduce(openingTicketPurposeAggregator(field.value || []), [])

            function onChange(value) {
                const nextValue = openingTicketPurposes.reduce(openingTicketPurposeAggregator(value), [])
                field.onChange(nextValue)
            }

            return {...field, value, onChange}
        }

        return (
            <div>
                <CheckboxToggle
                    {...excludedField(form.openingTicketPurposes())}>
                    <Row>
                        <Col sm={6}>
                            {openingTicketPurposes.slice(0, openingTicketPurposes.length / 2 + 1).map((openingTicketPurpose, index) => (
                                <Input
                                    key={index}
                                    type='checkbox'
                                    label={openingTicketPurpose.label}
                                    value={openingTicketPurpose.uid} />
                            ))}
                        </Col>
                        <Col sm={6}>
                            {openingTicketPurposes.slice(openingTicketPurposes.length / 2 + 1, openingTicketPurposes.length).map((openingTicketPurpose, index) => (
                                <Input
                                    key={index}
                                    type='checkbox'
                                    label={openingTicketPurpose.label}
                                    value={openingTicketPurpose.uid} />
                            ))}
                        </Col>
                    </Row>
                </CheckboxToggle>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendExcludeCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                </ButtonToolbar>
            </div>
        )
    }
}

ExcludeOpeningTicketPurposesFromInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: ExcludeOpeningTicketPurposesFromInterventionPeriodCmd.schema,
    action: EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED
})(ExcludeOpeningTicketPurposesFromInterventionPeriodForm)

ExcludeOpeningTicketPurposesFromInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.excludeOpeningTicketPurposesFromInterventionPeriodCmd,
}))(ExcludeOpeningTicketPurposesFromInterventionPeriodForm)

export default ExcludeOpeningTicketPurposesFromInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/ExcludeOpeningTicketPurposesFromInterventionPeriodForm.js